<template>
    <div class="aboutus-bg">
        <HeaderLanding mode="light" />

        <section class="aboutus-section">
            <div class="revolution-container">
                <!-- Badge -->
                <div class="badge-box">
                    <img src="@/assets/img/codesandbox.png" alt="codesandbox" class="codesandbox-icon" />
                    <span class="badge-text">SurPriz.ing</span>
                </div>
                <h1 class="about-title">Revolutionizing Customer <br/>Loyalty for MSMEs</h1>

                <section class="revolution-img">
                    <!-- Box 1: Stat (Purple) -->
                    <div class="stat-box highlight-box">
                    <h2>1.500+</h2>
                    <p>Point Collections Tracked for Every Purchase in Real Time</p>
                    </div>

                    <!-- Box 2: Image -->
                    <div class="grid-image short">
                    <img src="@/assets/img/pos1.jpg" alt="POS system" />
                    </div>

                    <!-- Box 3: Image -->
                    <div class="grid-image tall">
                    <img src="@/assets/img/pos2.jpg" alt="Mobile payment" />
                    </div>

                    <!-- Box 4: Image -->
                    <div class="grid-image medium">
                    <img src="@/assets/img/pos3.jpg" alt="Receipt scan" />
                    </div>

                    <!-- Box 5: Stat (Black) -->
                    <div class="stat-box dark-box">
                    <h2>99.9%</h2>
                    <p>Customer Satisfaction powered by QR<br />Feedback and Loyalty Rewards</p>
                    </div>

                </section>

                <section class="engagement-section">
                    <!-- LEFT SIDE -->
                    <div class="engagement-content">
                        <div class="badge-light">
                            <img src="@/assets/img/codepen.png" alt="codepen" class="icon" />
                            <span class="label">About</span>
                        </div>


                        <h2 class="engegement-title">Smart Customer Engagement for Small Businesses</h2>
                        <p class="engegement-subtitle">
                        Collect customer feedback through QR-based surveys and instantly reward them with digital vouchers or loyalty points.
                        </p>

                        <div class="feature">
                            <div class="feature-icon-box">
                                <img src="@/assets/img/codepen-purple.png" alt="icon" class="codepen-purple" />
                            </div>
                        <h3>Real-Time Feedback Collection</h3>
                        <p>Collect valuable customer insights instantly through easy-to-use QR surveys — no apps or complex setup needed.</p>
                        </div>

                        <div class="feature">
                            <div class="feature-icon-box">
                                <img src="@/assets/img/codepen-purple.png" alt="icon" class="codepen-purple" />
                            </div>
                        <h3>AI-Driven Insights</h3>
                        <p>Automatically analyze responses to uncover trends and areas of improvement, helping businesses make smarter decisions.</p>
                        </div>

                        <div class="feature">
                            <div class="feature-icon-box">
                                <img src="@/assets/img/codepen-purple.png" alt="icon" class="codepen-purple" />
                            </div>
                        <h3>Reward-First Loyalty System</h3>
                        <p>Drive repeat visits with digital e-vouchers and a flexible point system designed for small business success.</p>
                        </div>
                    </div>

                    <!-- RIGHT SIDE -->
                    <div class="engagement-graphic">
                        <div class="graphic-wrapper">
                            <img class="phone-mockup" src="@/assets/img/Screen 1.png" alt="Phone Mockup" />
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <section class="testimonial-section">
                    <h2 class="testimonial-heading">What users are saying<br />about SurPriz.ing</h2>

                    <div class="testimonial-grid">
                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=1" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic1.png" alt="Robert Fox" />
                                <div class="testimonial-user">
                                <div class="testimonial-name">Robert Fox</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                SurPriz.ing made it easy for us to collect real feedback from our customers. The QR surveys are quick...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=2" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic2.png" alt="Robert Fox" />
                                <div class="testimonial-user">
                                <div class="testimonial-name">Guy Hawkins</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                SurPriz.ing helped us understand what our customers really think. The AI feedback analysis highlighted service g...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=3" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic3.png" alt="Robert Fox" />

                                <div class="testimonial-user">
                                <div class="testimonial-name">Jacob Jones</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                I never thought gathering client feedback could be this simple. Our customers love scanning the code after their appointm...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=4" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic4.png" alt="Robert Fox" />

                                <div class="testimonial-user">
                                <div class="testimonial-name">Kristin Watson</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                We used SurPriz.ing for a pop-up market and it worked flawlessly. Collecting feedback and rewarding attendees wit...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=5" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic5.png" alt="Robert Fox" />

                                <div class="testimonial-user">
                                <div class="testimonial-name">Cody Fisher</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                We needed a way to improve our classes based on real feedback. SurPriz.ing gave us just that—plus a way to than...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=6" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic6.png" alt="Robert Fox" />

                                <div class="testimonial-user">
                                <div class="testimonial-name">Albert Flores</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                Our patients now feel heard. After each visit, they scan the QR code and leave feedback easily. In return, they get point...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=7" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic7.png" alt="Robert Fox" />
                                <div class="testimonial-user">
                                <div class="testimonial-name">Ralph Edwards</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                Our patients now feel heard. After each visit, they scan the QR code and leave feedback easily. In return, they get point...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>

                        <div class="testimonial-card">
                            <div class="testimonial-header">
                                <!-- <img src="https://i.pravatar.cc/100?img=8" alt="User" class="testimonial-avatar" /> -->
                                <img class="testimonial-avatar" src="@/assets/img/ProfilePic8.png" alt="Robert Fox" />
                                <div class="testimonial-user">
                                <div class="testimonial-name">Floyd Miles</div>
                                <div class="testimonial-role">CEO & Founder at AcmeCrop</div>
                                </div>
                            </div>
                            <p class="testimonial-text">
                                Our patients now feel heard. After each visit, they scan the QR code and leave feedback easily. In return, they get point...
                            </p>
                            <div class="testimonial-stars">
                                <img
                                    v-for="n in 5"
                                    :key="n"
                                    src="@/assets/img/StarRate.png"
                                    alt="star"
                                    class="star"
                                />
                            </div>
                        </div>
                    </div>
            </section>
            <section class="asked-questions">
                <div class="faq-container">
                    <!-- Left Column -->
                    <div class="faq-left">
                        <div class="faq-badge">
                            <img src="@/assets/img/codepen.png" alt="codepen" class="icon" />
                            <span class="label">FAQs</span>
                        </div>
                        <h2 class="faq-title">Frequently Asked<br class="desktop-break"/> Questions</h2>
                    </div>

                    <!-- Right Column -->
                    <div class="faq-content">
                        <div class="faq-box">
                            <div class="faq-open">
                            <h2>What is SurPriz.ing?</h2>
                            <span class="faq-icon">−</span>
                            <p>
                                SurPriz.ing is an AI-powered loyalty and feedback platform that helps small businesses
                                <br />gather customer feedback via QR codes and reward them with digital vouchers or
                                <br />points — no app downloads required.
                            </p>
                            </div>
                        </div>

                        <div class="faq-box">
                            <h2>What features does SurPriz.ing offer?</h2>
                            <span class="faq-icon">+</span>
                        </div>
                        <div class="faq-box">
                            <h2>Can it work with my POS system?</h2>
                            <span class="faq-icon">+</span>
                        </div>
                        <div class="faq-box">
                            <h2>Is the feedback public?</h2>
                            <span class="faq-icon">+</span>
                        </div>
                        <div class="faq-box">
                            <h2>Can my customers share their rewards?</h2>
                            <span class="faq-icon">+</span>
                        </div>
                    </div>
                </div>
            </section>
        <FooterLanding />
    </div>
</template>

<script>
import HeaderLanding from '@/components/HeaderLanding.vue';
import FooterLanding from '@/components/FooterLanding.vue';

export default {
  name: 'AboutUs',
  components: {
    HeaderLanding,
    FooterLanding,
  },
};
</script>




<style scoped>
.aboutus-bg {
    background-color: #FFFFFF;
    box-sizing: border-box;
    min-height: 100vh;
    overflow-x: hidden;
    font-family: 'Inter', sans-serif;
}

.aboutus-section {
    background-color: #ffffff; /* full width white */
    padding: 96px 80px;
    text-align: center;
}
.revolution-container {
    gap: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Badge Box */
.badge-box {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px 8px 8px;
  background-color: #fff;
  border: 1px solid #dfe1e6;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
  font-size: 14px;
  font-weight: 500;
  color: #808897;
}
.codesandbox-icon {
  width: 20px;
  height: 20px;
}

.about-title {
    font-family: Inter, sans-serif;
    font-size: 64px;
    font-weight: 600;
    color: #171717;
    line-height: 120%;
}
.about-subtitle {
  font-size: 18px;
  margin-top: 10px;
  color: #666;
}


.revolution-img {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: auto auto;
  gap: 32px;
  margin-top: 40px;
}

/* Purple Stat Box */
.stat-box.highlight-box {
  grid-column: 1 / span 2;
  grid-row: 1;
  height: 210px;
  background-color: #7970ef;
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
}

/* Short Image (Stacked under stat box but same grid cell) */
.grid-image.short {
  grid-column: 1 / span 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 240px; /* Push it below the stat box */
}

.grid-image.short img {
  height: 351px;
  width: 100%;
  object-fit: cover;
  border-radius: 24px;
}



/* Column 2 (Tall Image) */
.grid-image.tall {
  grid-column: 3 / span 2;
  grid-row: 1 / span 2;
}
.grid-image.tall img {
  height: 593px;
  width: 399px;
  object-fit: cover;
  border-radius: 24px;
}

/* Column 3 (Medium + Dark Stat Box) */
.grid-image.medium {
  grid-column: 5 / span 2;
  grid-row: 1;
}
.grid-image.medium img {
  height: 351px;
  width: 100%;
  object-fit: cover;
  border-radius: 24px;
}

/* Stat Box (Black Box) */
.stat-box.dark-box {
  grid-column: 5 / span 2;
  grid-row: 1;
  align-self: end; /* Align it to bottom of its grid cell */
  height: 210px;
  background-color: #171717;
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  margin-top: 375px; /* pushes it below the image visually */
}

/* Typography */
.stat-box h2 {
  font-size: 64px;
  margin: 0;
  line-height: 115%;
  font-weight: 600;
  text-align: left;
}
.stat-box p {
  font-size: 18px;
  margin-top: 12px;
  line-height: 170%;
  font-weight: 500;
  text-align: left;
}

.engagement-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 60px;
  padding: 80px 60px;
  /* background: linear-gradient(to right, #ffffff 50%, #e0dcff 50%); */
  /* background: linear-gradient(180deg, #7970EF 0%, #7970EF 30%, #FFFFFF 90%); */
}

.engagement-content {
  display: flex;
  flex-direction: column;
  gap: 16px; /* smaller gap */
}

.badge-light {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #fff;
  border: 1px solid #dfe1e6;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
  font-size: 14px;
  font-weight: 500;
  color: #808897;
  width: fit-content;
}

.icon {
  width: 20px;
  height: 20px;
}

.label {
  line-height: 160%;
  font-weight: 500;
}


.engegement-title {
  font-size: 42px;
  font-weight: 700;
  color: #1f2937; /* adjust as needed */
  margin-bottom: 16px;
  line-height: 1.3;
  text-align: left;
}

.engegement-subtitle {
    margin-bottom: 40px;
    width: 554px;
    position: relative;
    font-size: 18px;
    line-height: 155%;
    font-family: Inter;
    color: #666d80;
    text-align: left;
    display: inline-block;
}

.feature {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature h3 {
    width: 100%;
    position: relative;
    font-size: 18px;
    line-height: 150%;
    font-weight: 500;
    font-family: Inter;
    color: #171717;
    text-align: left;
    display: inline-block;
}
.feature p {
    width: 100%;
    position: relative;
    font-size: 16px;
    line-height: 150%;
    font-family: Inter;
    color: #666d80;
    text-align: left;
    display: inline-block;
}

.feature-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #EFEDFD; /* light gray background */
  border-color: #BDB6F6 ;
  border-radius:8px;
  margin-bottom: 8px; /* space between icon and text */
  overflow: hidden;
    flex-shrink: 0;
}

.codepen-purple {
  width: 24px;
  height: 24px;
}

.engagement-graphic {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #D3B5FF 0%, #B29EFF 50%, #6587FF 100%);
  overflow: hidden;
  border-radius: 24px;
}

/* Make grid fill the full area */
.graphic-wrapper :deep(.grid-background) {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
}

/* Wrapper should give enough space vertically */
.graphic-wrapper {
  position: relative;
  width: 100%;
  height: 700px; /* Adjust to match full mockup height */
}

/* Center the phone and make it look nice */
.phone-mockup {
  position: relative;
  z-index: 2;
  max-width: 320px;
  width: 100%;
  display: block;
  margin: 100px auto 0 auto; /* Center with top space */
}

/* Testimonial Section */
.testimonial-section {
  padding: 70px 20px;
  background-color: #F6F7F9; /* ← updated only this line */
  text-align: center;
}

.testimonial-heading {
  font-size: 48px;
  font-weight: 500;
  margin-bottom: 40px;
  line-height: 120%;
}

.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.testimonial-card {
  background-color: #fff;
  border-radius: 16px;
  padding: 20px;
  text-align: left;
  box-shadow: 0 1px 2px rgba(13, 13, 18, 0.06);
}

.testimonial-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.testimonial-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.testimonial-user .testimonial-name {
  font-weight: 600;
  font-size: 14px;
}

.testimonial-role {
  font-size: 12px;
  color: #6b7280;
}

.testimonial-text {
  font-size: 14px;
  color: #374151;
  margin-bottom: 10px;
}

.testimonial-stars {
  display: flex;
  gap: 4px; /* space between stars */
  margin-top: 12px; /* space above the stars */
  justify-content: flex-start; /* aligns stars to the left */
}

.star {
  width: 16px;  /* adjust to match your Figma */
  height: auto;
}


/* Asked Questions Section */
.asked-questions {
  background-color: #ffffff;
  padding: 80px 20px;
}

.faq-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 60px;
}

.faq-left {
  flex: 1;
  min-width: 280px;
  padding-left: 14px;
}

.faq-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #fff;
  border: 1px solid #dfe1e6;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
  font-size: 14px;
  font-weight: 500;
  color: #808897;
  width: fit-content;
  margin-bottom: 16px;
}

.faq-badge .icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.faq-title {
  font-size: 48px;
  font-weight: 500;
  color: #111827;
  line-height: 120%;
}

.faq-content {
  flex: 1.5;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.faq-box {
  position: relative;
  padding: 20px 50px 20px 24px; /* space for icon */
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background-color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faq-box:hover {
  background-color: #f3f4f6;
}

.faq-box h2 {
  font-size: 18px;
  font-weight: 600;
  color: #171717;
  line-height: 150%;
  margin-bottom: 8px;
}

.faq-open {
  background-color: #ffffff;
  border-radius: 12px;
}

.faq-open h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 150%;
  color: #111827;
}

.faq-open p {
  font-size: 15px;
  font-weight: 400;
  color: #4b5563;
  line-height: 150%;
}

.faq-icon {
  position: absolute;
  right: 20px;
  top: 24px;
  font-size: 20px;
  font-weight: 600;
  color: #5B49E9;
  pointer-events: none;
}



/* --------------------------------------------------- */
/* ========== MOBILE (≤768px) — your exact 425px spec ========== */
/* KEEPING all of your mobile measurements + tweaks */
@media (max-width: 768px) {

  .about-title{ font-size: 28px; }
  .aboutus-section { padding: 24px; }

  /* ——— Revolution ——— */
  .revolution-img{
    width: min(360px, calc(100vw - 32px));
    margin: 0 auto;
    display: grid !important;
    grid-template-columns: 106fr 122fr 106fr !important;
    grid-template-rows: 90px 90px !important;    /* base rows */
    gap: 10px !important;
    align-items: stretch;
  }

  /* placement (3-column indexing) */
 /* placement */
  .stat-box.highlight-box { grid-column: 1; grid-row: 1; }
  .grid-image.short       { grid-column: 1; grid-row: 2; }
  .grid-image.tall        { grid-column: 2; grid-row: 1 / span 2; }
  .grid-image.medium      { grid-column: 3; grid-row: 1; }
  .stat-box.dark-box      { grid-column: 3; grid-row: 2; }


  .revolution-img .stat-box,
  .revolution-img .grid-image{
    place-self: stretch;
  }
  .revolution-img .stat-box{
    height: 100% !important;
    min-height: 0 !important;
    padding: 8px !important;
    border-radius: 7.72px !important;
  }
  .grid-image.short,
  .grid-image.medium {
    height: 90px !important;
    width: 100% !important;
    object-fit: cover;
    border-radius: 7.72px !important;
  }

  .revolution-img .grid-image,
  .revolution-img .grid-image img{
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    display: block;
    border-radius: 7.72px !important;
  }

  .revolution-img .grid-image.short,
  .revolution-img .stat-box.dark-box { margin-top: 0 !important; }
  .revolution-img .grid-image { aspect-ratio: auto !important; }

  .revolution-img .stat-box h2{ font-size: 20px; line-height: 1.15; margin: 0; }
  .revolution-img .stat-box p { font-size: 5px;  line-height: 1.7;  margin: 0; }

  .revolution-img .stat-box.highlight-box { background:#7970EF; color:#fff; }
  .revolution-img .stat-box.dark-box      { background:#171717; color:#fff; }

  .stat-box.highlight-box h2,
  .stat-box.dark-box h2 { font-size: 20px; }
  .stat-box.highlight-box p,
  .stat-box.dark-box p { font-size: 5px; }

  /* your exact pixel tweaks to match Figma */
  .revolution-img .stat-box.highlight-box,
  .revolution-img .stat-box.dark-box {
    width: auto !important;            /* Figma: 114 */
    height: 68px !important;           /* Figma: 68 */
  }
  .revolution-img .grid-image.short{
    margin-top: -22px !important;
    height: 112px !important;          /* Figma: 112 */
  }
  .revolution-img .grid-image.medium{
    height: 112px !important;          /* Figma: 112 */
  }
  .revolution-img .stat-box.dark-box{
    margin-top: 20px !important;
  }

  /* ——— Engagement ——— */
  .engagement-section {
    display: grid;
    align-items: center;
    width: 100%;
    padding: 80px 0 0;
  }
  .engagement-content {
    display: flex;
    flex-direction: column;
    width: 90vw;
  }
  .badge-light {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background-color: #fff;
    border: 1px solid #dfe1e6;
    border-radius: 6px;
    box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
    font-size: 14px;
    font-weight: 500;
    color: #808897;
    width: fit-content;
  }
  .icon { width: 20px; height: 20px; }
  .label { line-height: 160%; font-weight: 500; }

  .engegement-title {
    padding-right: 50px;
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 16px;
    line-height: 1.3;
    text-align: left;
  }
  .engegement-subtitle {
    margin-bottom: 40px;
    position: relative;
    font-size: 14px;
    font-weight: 400;
    line-height: 155%;
    font-family: Inter;
    color: #666d80;
    text-align: left;
    display: inline-block;
    width: auto;
  }
  .feature {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .feature h3 {
    width: 100%;
    position: relative;
    font-size: 18px;
    line-height: 150%;
    font-weight: 500;
    font-family: Inter;
    color: #171717;
    text-align: left;
    display: inline-block;
  }
  .feature p {
    width: 100%;
    position: relative;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    font-family: Inter;
    color: #666d80;
    text-align: left;
    display: inline-block;
  }
  .feature-icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #EFEDFD;
    border-color: #BDB6F6;
    border-radius: 8px;
    margin-bottom: 8px;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
                rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }
  .engagement-graphic { display: none; }

  /* ——— Testimonials ——— */
  .testimonial-section {
    padding: 32px 24px;
    background-color: #F6F7F9;
    text-align: center;
  }
  .testimonial-heading {
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 40px;
    line-height: 120%;
    color: #171717;
    text-align: left;
  }
  .testimonial-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 24px;
    max-width: 1200px;
    margin: 0 auto;
  }
  .testimonial-card:nth-child(n+4) { display: none; }

  /* ——— FAQ ——— */
  .faq-title { font-size: 28px; }

  .desktop-break { display: none; }

  .faq-section { padding: 48px 24px; }
  .description-text { font-size: 12px; line-height: 1.5; margin-top: 16px; }

  .faq-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 16px;
  }

  /* 2-column label + pills */
  .faq-filter {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px 12px; /* row gap 8, column gap 12 */
    width: 100%;
    align-items: start;
  }
  .faq-filter .label {
    font-size: 14px;
    margin: 0;
    line-height: 36px; /* align with pills height visually */
    color: #A4ABB8;
  }
  .faq-filter .box-selected {
    display: grid;
    grid-template-columns: 1fr 1fr; /* two equal columns for General/Features, Billing wraps */
    gap: 8px;
  }
  .faq-filter .box-selected h4.faq{
    width: 100%;
    margin: 0;
    text-align: center;
  }

  .qbox { padding: 16px 20px; }

  .faq-questions {
    width: 100%;
    padding-bottom: 48px;
    gap: 16px;
  }
  .faq-general .title-section,
  .faq-component .title-section,
  .faq-billing .title-section {
    font-size: 20px;
  }
}




</style>
